import Proxy from './Proxy';

class ModusignProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/advertiser/modusign', parameters);
  }

  getStatus( status ) {
    return this.submit('get', `/${this.endpoint}/status-summary` );
  }

  embeddedView( docId ) {
    return this.submit('get', `/${this.endpoint}/embedded-view/${docId}`);
  }

  getTemplateList() {
    return this.submit('get', `/${this.endpoint}/template-list`);
  }


  createDocWithTemplate( data ) {
    return this.submit('post', `/${this.endpoint}/embedded-drafts/create-with-template`, data );
  }

  cteateDocWithUpload( data ) {
    return this.submit('post', `/${this.endpoint}/embedded-drafts`, data );
  }

  updateMetatdata( docId, data ) {
    return this.submit('post', `/${this.endpoint}/change-metadatas/${docId}`, data );
  }

}

export default ModusignProxy;
